<template>
  <div class="row">
    <div class="col-lg-12 col-md-12">
      <card class="shadow-lg">
        <div class="row content-add-btn">
          <button class="btn btn-secondary" @click="$router.go(-1)">
            <em class="fa fa-chevron-left"></em>
            {{ $t('common_words.exit') }}
          </button>
        </div>
        <hr />
        <form-wizard
          ref="formWizard"
          v-if="this.isCreate() || this.isUpdate()"
          @on-complete="storeUpdateCategory"
          title
          subtitle
          :back-button-text="$t('common_words.back')"
          :next-button-text="$t('common_words.next')"
          :finish-button-text="$t('common_words.save')"
          class="custom-padding-wz-header"
        >
          <tab-content
            :title="$t('common_words.category')"
            :before-change="() => validateStep('firstStep')"
          >
            <first-step
              ref="firstStep"
              @on-validated="onStepValidated"
              @showHideLoading="showHideLoading"
            ></first-step>
          </tab-content>
          <tab-content
            :title="$t('production.defects')"
            :before-change="() => validateStep('secondStep')"
          >
            <second-step
              ref="secondStep"
              @on-validated="onStepValidated"
              @showHideLoading="showHideLoading"
            ></second-step>
          </tab-content>
          <tab-content :title="$t('common_words.confirm')">
            <p class="cm-mg-p-wzd text-center">
              3. {{ $t('common_words.verify_inputed_information') }}
            </p>
            <br />
            <div class="row d-flex justify-content-center">
              <div class="col-12">
                <table class="table">
                  <tbody>
                    <tr class="shadow-sm">
                      <td>
                        <h6 class="mb-2">
                          <strong
                            >{{ $t('common_words.category_name') }}:</strong
                          >
                        </h6>
                        {{ defectCategoryForm.name }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6 class="mb-2">
                          <strong
                            >{{ $t('common_words.abbreviation') }}:</strong
                          >
                        </h6>
                        <template v-if="isSet(defectCategoryForm.abbreviature)">
                          {{ defectCategoryForm.abbreviature }}
                        </template>
                        <el-tag type="warning" v-else>{{
                          $t('common_words.no_assigned')
                        }}</el-tag>
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6 class="mb-2">
                          <strong>{{ $t('common_words.order') }}:</strong>
                        </h6>
                        <template v-if="isSet(defectCategoryForm.order)">
                          {{ defectCategoryForm.order }}
                        </template>
                        <el-tag type="warning" v-else>{{
                          $t('common_words.no_assigned')
                        }}</el-tag>
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6 class="mb-2">
                          <strong>{{ $t('common_words.type') }}:</strong>
                        </h6>
                        {{ getTypeLabel(defectCategoryForm.type) }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6 class="mb-2">
                          <strong>{{ $t('production.defects') }}:</strong>
                        </h6>
                        <div
                          class="mb-2"
                          v-for="(
                            _, index
                          ) in defectCategoryForm.defect_quantity"
                          :key="index"
                        >
                          <el-tag
                            style="height: auto; color: black; width: 100%"
                            type="info"
                          >
                            <div class="row pt-2">
                              <div class="col-12 col-sm-4 col-lg-2">
                                <h6 class="mb-2">
                                  <strong>{{
                                    $t('common_words.order')
                                  }}</strong>
                                </h6>
                                <template
                                  v-if="
                                    isSet(
                                      defectCategoryForm.defect_order[index]
                                    )
                                  "
                                >
                                  <p>
                                    {{ defectCategoryForm.defect_order[index] }}
                                  </p>
                                </template>
                                <el-tag type="warning" v-else>{{
                                  $t('common_words.no_assigned')
                                }}</el-tag>
                              </div>
                              <div class="col-12 col-sm-8 col-lg-5">
                                <h6 class="mb-2">
                                  <strong
                                    >{{ $t('production.defect') }}
                                    {{ index + 1 }}</strong
                                  >
                                </h6>
                                <p>
                                  {{ defectCategoryForm.defect_name[index] }}
                                </p>
                              </div>
                              <div class="col-12 col-sm-8 col-lg-3">
                                <h6 class="mb-2">
                                  <strong
                                    >{{ $t('common_words.abbreviation') }}
                                  </strong>
                                </h6>
                                <template
                                  v-if="
                                    isSet(
                                      defectCategoryForm.defect_abbreviature[
                                        index
                                      ]
                                    )
                                  "
                                >
                                  <p>
                                    {{
                                      defectCategoryForm.defect_abbreviature[
                                        index
                                      ]
                                    }}
                                  </p>
                                </template>
                                <el-tag type="warning" v-else>{{
                                  $t('common_words.no_assigned')
                                }}</el-tag>
                              </div>
                              <div class="col-12 col-sm-4 col-lg-2">
                                <h6 class="mb-2">
                                  <strong
                                    >{{ $t('common_words.deductible') }}
                                  </strong>
                                </h6>
                                <p>
                                  {{
                                    defectCategoryForm.defect_deductible[index]
                                      ? $t('common_words.yes')
                                      : $t('common_words.no')
                                  }}
                                </p>
                              </div>
                            </div>
                          </el-tag>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </tab-content>
        </form-wizard>
        <div v-else>
          <br />
          <h5 class="text-muted text-center">
            {{ $t('common_words.no_permissions_operations') }}
          </h5>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { isset } from 'src/util/Util.js';
import { showContinue, resetObjectProperties } from 'src/util/Util.js';
import FirstStep from './steps/FirstStep.vue';
import i18n from 'src/i18n';
import MixinAlert from 'src/mixins/mixin-alert';
import MixinLoading from 'src/mixins/mixin-loading';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import SecondStep from './steps/SecondStep.vue';

export default {
  components: {
    FirstStep,
    SecondStep,
  },
  data() {
    return {
      title: '',
      defectCategoryForm: {
        defect_id: [],
        name: null,
        abbreviature: null,
        order: null,
        type: null,
        businesses_id: [],
        businesses_names: [],
        defect_order: [1],
        defect_name: [''],
        defect_abbreviature: [''],
        defect_deductible: [true],
        defect_quantity: 1,
      },
      renderComponent: true,
    };
  },

  computed: {
    types() {
      return [
        { id: 'calidad local', name: i18n.t('boxinspection.local_quality') },
        {
          id: 'calidad exterior',
          name: i18n.t('boxinspection.external_quality'),
        },
      ];
    },
  },

  mixins: [MixinAlert, MixinLoading, MixinMenu, MixinPermissions],

  methods: {
    isSet(data) {
      return isset(data);
    },
    getTypeLabel(id) {
      if (isset(id)) {
        const type = this.types.find((item) => item.id === id);

        return type ? type.name : null;
      }
    },
    cleanAllSteps() {
      this.$refs.firstStep.model = {
        ...resetObjectProperties({ ...this.$refs.firstStep.model }),
      };

      this.$set(this.$refs.firstStep.model, 'businesses_id', []);
      this.$set(this.$refs.firstStep.model, 'businesses_names', []);
      this.$set(this.$refs.firstStep, 'businessesInitial', []);

      this.$refs.secondStep.model = {
        ...resetObjectProperties({ ...this.$refs.secondStep.model }),
        defect_order: [1],
        defect_deductible: [true],
        defect_quantity: 1,
      };
    },

    validateStep(ref) {
      return this.$refs[ref].validate();
    },

    onStepValidated(model) {
      this.defectCategoryForm = { ...this.defectCategoryForm, ...model };
    },

    storeUpdateCategory() {
      const payload = {
        id: this.defectCategoryForm.id,
        route: 'quality/defectgroups',
        expected_defect_count: this.defectCategoryForm.defect_quantity,
        business_ids: this.defectCategoryForm.businesses_id,
        name: this.defectCategoryForm.name,
        abreviature: this.defectCategoryForm.abreviature,
        order: this.defectCategoryForm.order,
        type: this.defectCategoryForm.type,
        defects: this.defectCategoryForm.defect_name.map(
          (defectName, index) => ({
            id: this.defectCategoryForm.defect_id[index],
            order: this.defectCategoryForm.defect_order[index],
            name: defectName,
            abreviature: this.defectCategoryForm.defect_abbreviature[index],
            discountable: this.defectCategoryForm.defect_deductible[index],
          })
        ),
      };

      this.showHideLoading(true);

      if (this.defectCategoryForm.isEdit) {
        if (this.isUpdate()) {
          Axios.updateMaster(payload)
            .then((response) => {
              this.showHideLoading();
              showContinue(
                this,
                response.data.message ? response.data.message : response.errors,
                '/quality/defectgroups',
                null
              );
            })
            .catch((error) => this.showMessageErrors(error));
        } else {
          this.showMessageAccess();
          this.showHideLoading();
        }
      } else {
        if (this.isCreate()) {
          Axios.saveMaster(payload)
            .then((response) => {
              this.showHideLoading();
              showContinue(
                this,
                response.data.message ? response.data.message : response.errors,
                '/quality/defectgroups',
                null
              );
            })
            .catch((error) => this.showMessageErrors(error));
        } else {
          this.showMessageAccess();
          this.showHideLoading();
        }
      }
    },
  },

  mounted() {
    this.selectedItemOnMenu('quality');
  },

  beforeDestroy() {
    sessionStorage.removeItem('editForm');
    this.deselectedItemOnMenu('quality');
  },
};
</script>
